import axios, {InternalAxiosRequestConfig, AxiosError, AxiosResponseHeaders, RawAxiosResponseHeaders} from 'axios';

import {TYPE_QUERY_KEY} from 'hooks/queries';
import {ensighten} from 'shared/Ensighten/components';
import {EnsightenActionResult} from 'shared/Ensighten/types';

interface CustomAxiosRequestConfig extends InternalAxiosRequestConfig {
  apiAction?: TYPE_QUERY_KEY;
}

const getSuspiciousActivityHeader = (
  responseHeaders: RawAxiosResponseHeaders | AxiosResponseHeaders | undefined
): string | undefined => {
  const SUSPICIOUS_ACTIVITY_HEADER = 'x-sp-rs';

  return responseHeaders?.[SUSPICIOUS_ACTIVITY_HEADER];
};

axios.interceptors.response.use(
  (response) => {
    const suspicousResponseActivty = getSuspiciousActivityHeader(response.headers);
    suspicousResponseActivty && ensighten.setMitigationType(suspicousResponseActivty);

    const axiosResponseconfig: CustomAxiosRequestConfig = response.config;
    const apiAction = axiosResponseconfig['apiAction'];
    apiAction &&
      ensighten.addMessage({
        messageID: 'Message',
        messageType: EnsightenActionResult.SUCCESSFUL,
        messageDescription: `${apiAction} `
      });
    return Promise.resolve(response);
  },
  (error: AxiosError) => {
    const suspicousErrorActivty = getSuspiciousActivityHeader(error?.response?.headers);
    suspicousErrorActivty && ensighten.setMitigationType(suspicousErrorActivty);

    const errorConfig: CustomAxiosRequestConfig | undefined = error.config;
    const apiAction = errorConfig ? errorConfig['apiAction'] : undefined;
    apiAction &&
      ensighten.addMessage({
        messageID: 'Message',
        messageType: EnsightenActionResult.UNSUCCESSFUL,
        messageDescription: `${apiAction} `
      });
    return Promise.reject(error);
  }
);
